'use es6';

import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { throttle } from 'underscore';
import { getIsPortalUngatedForSkipVisibilityChecker } from 'simple-menus-core/selectors/Auth';
import { jsx as _jsx } from "react/jsx-runtime";
const THROTTLE_TIME = 200;
const PIXEL_OFFSET = 100;
export default function withVisibilityChecker() {
  return Component => {
    const WithVisibilityChecker = props => {
      const [isVisible, setIsVisible] = useState(false);
      const nodeRef = useRef(null);
      // For Jira https://issues.hubspotcentral.com/browse/CG-54811
      // Ungated portals force ALL nodes to have isVisible={true}
      const isPortalUngatedForSkipVisibilityChecker = useSelector(getIsPortalUngatedForSkipVisibilityChecker);
      const updateVisibility = useCallback(() => {
        if (!nodeRef.current) return;
        const {
          top
        } = nodeRef.current.getBoundingClientRect();
        const isCurrentlyVisible = top < window.innerHeight + PIXEL_OFFSET && top > -PIXEL_OFFSET;
        if (isVisible !== isCurrentlyVisible) {
          setIsVisible(isCurrentlyVisible);
        }
      }, [isVisible]);
      const handleScroll = useMemo(() => throttle(() => {
        updateVisibility();
      }, THROTTLE_TIME), [updateVisibility]);
      useEffect(() => {
        const timeout = setTimeout(() => {
          updateVisibility();
        }, 0);

        /* Have to do both wheel and scroll, module forms do not scroll document, but settings does */
        document.addEventListener('scroll', handleScroll);
        document.addEventListener('wheel', handleScroll);
        return () => {
          if (timeout) {
            clearTimeout(timeout);
          }
          document.removeEventListener('scroll', handleScroll);
          document.removeEventListener('wheel', handleScroll);
        };
      }, [handleScroll, updateVisibility]);
      return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
        isVisible: isPortalUngatedForSkipVisibilityChecker ? true : isVisible,
        ref: nodeRef
      }));
    };
    return WithVisibilityChecker;
  };
}